var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters, mapActions } from 'vuex';
import { CART } from '@/stores/defs';
import menuItemMixin from '@Mixin/menuItemMixin';
import EventBus from '@EventBus';
var cartItemMixin = {
    mixins: [
        menuItemMixin,
    ],
    computed: __assign({}, mapGetters({
        items: CART.ITEMS,
    })),
    methods: __assign({}, mapActions({
        incrementItem: CART.INCREMENT_ITEM,
        decrementItem: CART.DECREMENT_ITEM,
        removeItem: CART.REMOVE_ITEM,
        cartAddItem: CART.ADD_ITEM,
    }), { editItem: function (index) {
            var item = this.items[index];
            var route = this.getItemRoute(item);
            route.params['edit'] = true;
            route.params['itemIndex'] = index;
            this.$tpa.trackCartEditItem(item.name);
            this.$router.push(route);
        },
        removeFromCart: function (index) {
            var item = this.items[index];
            this.confirmItemDeletion(item);
        },
        // TODO, this only works on items without options
        // add options object with defaults
        // (or have cart item model set option defaults)
        _addItemToCart: function (item, quantity) {
            item.quantity = quantity;
            this.cartAddItem(item);
        },
        confirmItemDeletion: function (item) {
            var _this = this;
            this.$modal.show("dialog", {
                text: "Are you sure you want to delete this item?",
                buttons: [
                    {
                        title: "Yes",
                        handler: function () {
                            EventBus.$emit('item-removed', item);
                            var lastItem = (_this.items.length === 1);
                            //  remove offer before deleting
                            if (!item.bundle && item.discounts.length) {
                                item.discounts.forEach(function (offer) {
                                    _this.removeOfferFromItem(offer);
                                });
                            }
                            _this.removeItem(item).then(function () {
                                EventBus.$emit('after-item-removed');
                                _this.$tpa.trackCartRemoveItem(item.name);
                                if (lastItem) {
                                    _this._navigateToHome();
                                }
                            });
                            _this.$modal.hide("dialog");
                        }
                    },
                    {
                        title: "No",
                    },
                ],
            });
        } }),
};
export default cartItemMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/cartItemMixin.ts
// module id = u76a
// module chunks = 18